export const validateEmail = (value: string) => {
  if (!value) {
    return true;
  }

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "El mail debe ser un correo válido";
};

export const validatePhone = (value: string) => {
  if (!value) {
    return true;
  }

  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) {
    return "El número de celular debe contener solo números";
  }

  return true;
};

export const validateDocumentNumber = (value: string) => {
  if (!value?.trim()) {
    return "El número de documento es obligatorio";
  }

  if (!/^\d+$/.test(value.trim())) {
    return "El número de documento debe contener solo números";
  }

  return true;
};

/** Las fechas de vencimiento de transportistas (VTV, ART, seguro, licencia) no pueden estar
 * vencidas: deben ser posteriores al día de hoy. */
export const validateNotExpired = (value: Date | string | null | undefined) => {
  if (!value) {
    return true;
  }

  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (isNaN(date.getTime())) {
    return true;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  return date.getTime() > today.getTime() || "La fecha no puede estar vencida";
};
